<app-ar-template-taxonomy-component
    [data]="taxonomiesList"
    [savedSelectionId]="savedTaxonomyId"
    (onTaxonomySelected)="onTaxonomySelected($event)"
></app-ar-template-taxonomy-component>
